
const Icon = ({ icon, className } : {icon: string;
	className?: string;}) => {
	return (
		<svg className={`icon ${className ? className : ""}`}>
			<use href={`#${icon}`}></use>
		</svg>
	);
};

export default Icon;
